import BaseRequest from '../lib/BaseRequest'
export default class ExchangeBalanceRequest extends BaseRequest {
  getExchangeBalance(params) {
    let url = '/admin/getExchangeBalanceDetail';
    return this.get(url,params);
  }
}